import React, { useContext } from "react";
import RegisterModal from "../modals/RegisterModal";
import Logo from "../Logo";
import { ModelContext } from "../../contexts/ModelContextProvider";
import LoginForm from "../forms/LoginForm";
import CheckYourInbox from "../modals/CheckYourInbox";
import { useUser } from "../../contexts/UserContextProvider";
import styles from "./LoginCard.module.css";

const LoginCard = () => {
  const { setOpen, isOpenVerifyAlert, VerifyAlertClose } =
    useContext(ModelContext);
  const { userInfo } = useUser();
  return (
    <section>
      <div className={`row ${styles.cardDimensions} center`}>
        <div
          className={`col-md-6 ${styles.leftContainer} p-5 p-md-6 d-flex flex-column justify-content-between`}
        >
          <div className="pt-lg-5">
            <Logo
              style={{ width: "70px", height: "70px", borderRadius: "20px" }}
            />
            <h3 className="pt-4 mh-80">
              Revolutionizing Research Publishing & Management
            </h3>
          </div>
          <p>
            New to hyvv? Create a new account{" "}
            <span onClick={setOpen} style={{ cursor: "pointer" ,color:"var(--gray)" }}>
              here.
            </span>
          </p>
          {/* <RegisterModal /> */}
        </div>

        <div
          className={`col-md-6 p-5 p-md-6 d-flex align-items-center ${styles.rightContainer}`}
        >
          <LoginForm />
        </div>
      </div>
      {/* alert model for user */}
      {isOpenVerifyAlert && (
        <CheckYourInbox
          open={isOpenVerifyAlert}
          setClose={VerifyAlertClose}
          onClick={VerifyAlertClose}
          email={userInfo?.email}
        />
      )}
      <RegisterModal />
    </section>
  );
};

export default LoginCard;
